"use client";
import { useState, useEffect } from "react";
import { Modal, Input, Spin } from "antd";
import { LoadingOutlined } from '@ant-design/icons';
import styles from './PasswordModal.module.scss';
import classNames from "classnames";
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../redux/store';
import { RootState } from '../../redux/reducers/index';
import Image from 'next/image';
import logo from '../../../public/Brand-logo.png';
import { getAccess } from '@/redux/api/admin/settingThunk';

interface Props {
    visible: boolean;
    onClose: () => void;
}

const PasswordModal: React.FC<Props> = ({ visible, onClose }) => {

    const [errMessage, setErrMessage] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const dispatch = useDispatch<AppDispatch>();
    const { isLoading} = useSelector((state: RootState) => state.setting);


    const handlePasswordSubmit = () => {
        if (!password.trim()) {
            setErrMessage("Password field cannot be empty.");
            return;
        }
        setErrMessage("");
        dispatch(getAccess({ password })).then((result) => {
        if(result.payload.access===true){
        onClose();
        }else{
         setErrMessage("Access Denied!");
        }
        });
    };

    return (
        <>
            <Modal
                open={visible}
                footer={null}
                onCancel={onClose}
                width="400px"
                centered
                maskClosable={false}
                keyboard={false}
            >

                <div className={classNames(styles.loginContainer, 'primary_font')}>

                    <div>
                        <Image src={logo} alt="Candidate Review" priority />
                    </div>

                    <div className={classNames(styles.otp_header, 'primary_font', 'primary_text_color')}>Enter Password </div>

                    <div className={classNames(styles.otp_box)}>

                        <Input
                            placeholder='Enter Password'
                            onChange={(e) => setPassword(e.target.value)}
                            className={classNames(styles.login_email, 'text-500', 'text16', { [styles.error_border]: errMessage })}
                        />

                        {errMessage && <p className={classNames(styles.error_message)}>{errMessage}</p>}
                    </div>


                    <button
                        className={classNames(styles.login_btn, 'secondary_font', 'secondary_background')}
                        disabled={isLoading}
                        onClick={handlePasswordSubmit}
                    >
                        Continue {isLoading && <Spin indicator={<LoadingOutlined spin />} style={{ color: "white", marginLeft: "4px" }} />}
                    </button>

                </div>

            </Modal>
        </>
    );
};

export default PasswordModal;
